'use client';

import Link from 'next/link';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { GoArrowUpRight } from 'react-icons/go';

export function Stores({
  stores,
  subtitle,
  title,
  description,
}: {
  stores: TDynamicData[];
  subtitle: string;
  title: string;
  description: string;
}) {
  return (
    <section
      className={cn(
        'custom-section',
        'gap-6 py-5 sm:gap-8 sm:py-8 md:gap-10 md:py-10 lg:gap-[50px] lg:py-[50px]',
      )}
    >
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-6 md:flex-row md:items-center md:justify-between',
        )}
      >
        <Heading subtitle={subtitle} title={title} />
        <Paragraph size="base" color="foreground" className="w-full sm:max-w-[456px]">
          {description}
        </Paragraph>
      </div>
      <div
        className={cn(
          'custom-container',
          'hidden grid-cols-2 gap-6 sm:grid md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5',
        )}
      >
        {stores.map(store => (
          <StoreCard store={store} key={store.id} />
        ))}
      </div>
    </section>
  );
}

function StoreCard({ store }: { store: TDynamicData }) {
  const { t } = useTranslations();

  return (
    <Link
      href={`/nahradne-diely-na-okna-a-dvere-${store.slug}`}
      className={cn(
        'ea-store-card',
        'col-span-1 flex w-full flex-col items-start justify-start gap-[6px] rounded-[12px] bg-white p-3 transition-all hover:opacity-90 sm:p-4 lg:gap-2 lg:p-6',
      )}
    >
      <div className="flex w-full items-start justify-between gap-2">
        <Heading title={store.name} tag="h3" visualTag="h6" />
        <GoArrowUpRight size={24} className="text-border" />
      </div>
      <Paragraph size="sm" color="foreground">
        {store?.fields[0]?.value}
      </Paragraph>
      <Paragraph size="sm" className="text-primary underline">
        {t('text3877')}
      </Paragraph>
    </Link>
  );
}
